import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TranslationService } from 'src/app/core/services/translation/translation.service';

@Component({
  selector: 'app-coupon-status-popup',
  templateUrl: './coupon-status-popup.component.html',
  styleUrls: ['./coupon-status-popup.component.scss'],
})
/**
 * CouponStatusPopupComponent
 */
export class CouponStatusPopupComponent implements OnInit {
  @Output() closeClick = new EventEmitter();
  @Input() couponData: any;

  chipSelected = '';
  currency = '';

  labels = {
    active: 'active',
    redeemed: 'redeemed',
    canceled: 'canceled',
    couponStatusText: 'coupon-status',
    cancel: 'cancel',
    changeStatus: 'change-status',
    textCancel: 'cancel-coupon',
    confirmCancel: 'confirm-cancel',
    formDate: 'redemption-date',
    formInvoice: 'invoice',
    formValue: 'discount-value',
    formReseller: 'reseller',
  };

  chipOptions = [
    { name: this.labels.active, icon: 'receipt' },
    { name: this.labels.redeemed, icon: 'check_circle' },
    { name: this.labels.canceled, icon: 'cancel' },
  ];

  form = new FormGroup({
    date: new FormControl<Date>(new Date()),
    invoice: new FormControl<string>(''),
    discount: new FormControl<string>(''),
    reseller: new FormControl<string>(''),
    cancel: new FormControl<boolean>(false),
  });

  chipListCtrl = new FormControl();

  /**
   * constructor
   */
  constructor(private translationService: TranslationService) {}

  /**
   * onInit
   */
  ngOnInit(): void {
    this.translationService.translateObject(this.labels);
    this.chipOptions.forEach((item) => {
      if (this.couponData.statusCheck[0].includes(item.name.toLowerCase())) {
        if (item.name === 'Redeemed') {
          this.setFormValues();
        }
      }
    });
    this.currency = this.translationService.getCurrencySymbol()!;
  }

  /**
   * setFormValues
   */
  setFormValues(): void {
    this.form.get('discount')?.setValue(this.couponData.cost);
  }

  /**
   * checkChipOption
   * @param {string} item
   * @return {boolean}
   */
  checkChipOption(item: any): boolean {
    return item === this.chipSelected;
  }

  /**
   * emitCloseClick
   */
  emitCloseClick() {
    this.closeClick.emit();
  }
}
